import { render, staticRenderFns } from "./recieved-stock-owner-row.vue?vue&type=template&id=531ed172&"
import script from "./recieved-stock-owner-row.vue?vue&type=script&lang=js&"
export * from "./recieved-stock-owner-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports